"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInput = exports.StyledLabel = exports.StyledLabeledInput = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Input = _interopRequireDefault(require("../Input"));

var _LabelText = _interopRequireDefault(require("../../TextElements/BasicTextElements/LabelText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
// internal components
var StyledLabeledInput = _styledComponents.default.div.withConfig({
  displayName: "LabeledInputstyles__StyledLabeledInput",
  componentId: "sc-8mg3yc-0"
})(["display:", ";align-items:", ";;"], function (props) {
  return props.layout === 'split' ? 'flex' : 'initial';
}, function (props) {
  return props.layout === 'split' ? 'baseline' : 'initial';
});

exports.StyledLabeledInput = StyledLabeledInput;
var StyledLabel = (0, _styledComponents.default)(_LabelText.default).withConfig({
  displayName: "LabeledInputstyles__StyledLabel",
  componentId: "sc-8mg3yc-1"
})(["flex:", ";"], function (props) {
  return props.layout === 'split' ? '1' : 'none';
});
exports.StyledLabel = StyledLabel;
var StyledInput = (0, _styledComponents.default)(_Input.default).withConfig({
  displayName: "LabeledInputstyles__StyledInput",
  componentId: "sc-8mg3yc-2"
})(["flex:", ";"], function (props) {
  return props.layout === 'split' ? '1' : 'none';
});
exports.StyledInput = StyledInput;